import React from 'react' // eslint-disable-line no-unused-vars
import SearchForm from './SearchForm'
import { validateField } from '../pages/functions'
import '../css/forms/default-forms.css'
import PaginatedDocumentsTable from './tables/PaginatedDocumentsTable'
import PiSearchResult from './PiSearchResult'
import HeroImage from './HeroImage'
import { connect } from 'react-redux'
import { addNotification as notify } from 'reapop'
import history from '../history'
import CountryAwareComponent from './CountryAwareComponent'
import { REF_DATA, NO_NAME_DISPLAYED, DOWNLOAD_BUTTON } from '../constants'
import { v4 as uuidv4 } from 'uuid'

import StaticConfig from './StaticConfig'
import { auditSearch } from './Audit'
import { triggerSSO } from './InitiateSSO'
import { api } from './index.api'
import Footer from './Footer'
import imgHeaderDocumentSearchMobile from './assets/img_header_document_search_mobile.jpg'
import imgHeaderDocumentSearch from './assets/img_header_document_search.jpg'
import { Link } from 'react-router-dom'

class Search extends CountryAwareComponent {
  constructor (props) {
    super(props)

    // Show mobile version if screen width is below 576px
    this.widthQuery = window.matchMedia('(min-width: 576px)');

    this.state = {
      searchItems: [],
      searching: false,
      searchedProductCode: null,
      searchPerformed: false,
      searchAuditId: null,
      searchId: uuidv4(),
      searchUserType: '',
      showModal: false,
      showMobileVersion: !this.widthQuery.matches
    }

    this.componentName = 'Search'
    this.onSubmit = this.onSubmit.bind(this)
    this.piSearchLinks = ''
    this.showMessage = false

    // Keys that identify data elements to include in the table columns,
    // with associated formatting
    this.columnKeys = [
      {
          key: 'name__v',
          style: { fontWeight: 'bold' },
          width: '60%'
      },
      {
          key: 'gmi_approval_date__c',
          style: { whiteSpace: 'nowrap' },
          width: '15%'
      },
      {
          key: 'language__v',
          isArray: true,
          width: '10%'
      },
      {
          key: DOWNLOAD_BUTTON,
          style: { textAlign: 'right' },
          width: '15%'
      }
    ]
  }

  componentDidMount () {
    this.widthQuery.addEventListener('change', this.handleMediaChange)

    if (this.props.location.state != null) {
      this.refs.SearchForm.getWrappedInstance()._init(
        this.props.location.state
      )

      this.onSubmit(this.props.location.state)
    }
  }

  componentWillUnmount () {
    this.widthQuery.removeEventListener('change', this.handleMediaChange)
  }

  handleMediaChange = (e) => this.setState({ showMobileVersion: !e.matches })

  _onThisClick = () => {
    history.push('/submit-inquiry')
  };

  onSubmit (postData, callbackFn) {
    // Bug fix: Return is postData is {}
    if (!postData.product) {
      return false
    }

    this.showMessage = false
    this.setState({ searchUserType: postData.searchUserType })
    this.setState({ searching: true })
    api.searchDocuments(
      postData,
      this._searchSuccessHandler.bind(this, postData),
      this._searchFailureHandler.bind(this)
    )
  }

  _searchSuccessHandler = (postData, response) => {
    if (response.status === 200) {
      response.json().then(responseJson => {
        if (
          StaticConfig.Context.UserType === 'HCP' &&
          responseJson.length > 25
        ) {
          responseJson.length = 0
          this.showMessage = true
        }
        this._piSearchResult(postData.product)

        this.setState({
          searching: false,
          searchPerformed: true,
          searchItems: responseJson,
          searchId: uuidv4(),
          searchedProductCode: postData.product
        })
        this._auditSearchEvent(postData, responseJson)
      })
    } else if (response.status === 401) {
      this._showNotification(
        'Error',
        'You are not authorized to perform this action. Please log in again.',
        'error'
      )
      setTimeout(() => triggerSSO(this.props.pageContent.content.lang), 3000)
    } else {
      this._showNotification(
        'Error',
        'Error occurred while submitting query',
        'error'
      )
      this.setState({ searching: false })
    }
  };

  _searchFailureHandler = error => { /* eslint-disable-line */
    this.setState({ searching: false })
    this.showNotification('Error', 'Error occurred while submitting query', 'error')
  };

  _auditSearchEvent = (data, result) => {
    const productDetails = this._findSearchedProduct(data.product)
    const scope =
      data.searchUserType === 'ABBVIE_EMPLOYEE' ? 'Internal' : 'External'
    const keywords = data.keywords

    const searchCriteria = {
      productName: productDetails.name,
      category: data.category,
      country: data.country,
      scope: scope,
      keyword: keywords,
      topic: null
    }

    auditSearch(searchCriteria, result, this.setSearchAuditId)
  };

  setSearchAuditId = searchAuditId => {
    this.setState({ searchAuditId })
  };

  _piSearchResult = productValue => {
    const matchedProduct = this._findSearchedProduct(productValue)
    this.piSearchLinks = matchedProduct ? matchedProduct.piSearchLinks : ''
  };

  _findSearchedProduct = productValue => {
    let matchedProduct = {}

    const refData = this.props.referenceData.filter(function (item) {
      return item.type === REF_DATA
    })[0]

    if (refData != null) {
      matchedProduct = refData.referenceData.ProductMaster.find(
        p => p.veevaProductCode === productValue
      )
    }
    return matchedProduct
  };

  _showNotification = (title, message, status) => {
    const { notify } = this.props
    notify({
      title,
      message,
      status,
      position: 'tr',
      dismissible: true,
      dismissAfter: 3000
    })
  };

  render () {
    const languageContent = this.props.pageContent.content
    const searchContent = languageContent.module.searchDocument
    const tableContainerStyle = this.state.showMobileVersion ? { marginBottom: '0px' } : {}
    const columnNames = [
      searchContent.documentTitle,
      searchContent.effectiveDate,
      searchContent.language,
      NO_NAME_DISPLAYED
    ]
    const searchHelpText = languageContent.module.searchDocument.searchHelpText || '';

    const jsx = (
      <div className='page-container'>
        <div className='page-content search-margin-bottom'>
          <HeroImage title={languageContent.module.searchDocument.title} imageMobile={imgHeaderDocumentSearchMobile} imageDesktop={imgHeaderDocumentSearch} />
          <div className='row search-container mr-0'>
            <div className='col'>
              <div className='container'>
                <SearchForm
                  ref='SearchForm'
                  submit={this.onSubmit}
                  isSearching={this.state.searching}
                  _showNotification={this._showNotification}
                />
                {
                    (this.state.searchItems.length === 0 && this.state.searchPerformed && !this.state.searching) &&
                    <div style={{ maxWidth: '650px', marginTop: '1rem' }}>
                        <div className='warning-message'>
                            <i className='fa fa-times-circle'/>{languageContent.module.products.details.noDocumentsFound}
                        </div>
                    </div>
                }
              </div>
            </div>
          </div>
          <div className='row search-results-container'>
            <div className='col'>
              <div className='container' style={{ marginTop: '0px', ...tableContainerStyle }}>
                {this.showMessage ? (
                  <div className='row'>
                    <div className='col criteria-too-broad'>
                      <h4>
                        {' '}
                        {
                          languageContent.module.searchDocument
                            .searchCriteriaTooBroadMsg
                        }{' '}
                      </h4>
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {
                  this.state.searchPerformed &&
                  <div className='row mb-3'>
                    <div className='col widget-mb-0-row prescribing-info'>
                      <PiSearchResult
                        searchUserType={this.state.searchUserType}
                        piSearchLinks={this.piSearchLinks}
                        lang={searchContent}
                        language={languageContent.lang}
                      />
                    </div>
                  </div>
                }
                {
                  this.state.searchItems.length > 0 &&
                  <React.Fragment>
                    <div className='mobile-background'>
                      <div className='mobile-padding'>
                        <PaginatedDocumentsTable
                            // Key forces pagination component to reset state when search result changes
                            key={this.state.searchId}
                            id='search-documentation'
                            results={this.state.searchItems}
                            searchedProductCode={this.state.searchedProductCode}
                            columnNames={columnNames}
                            columnKeys={this.columnKeys}
                            searchAuditId={this.state.searchAuditId}
                            showMobileVersion={this.state.showMobileVersion}
                        />
                        <p>
                          {searchContent.piSearchResultNote}
                        </p>
                      </div>
                    </div>
                  </React.Fragment>
                }
              </div>
            </div>
          </div>
          <div className='row search-container mr-0'>
            <div className='col'>
              <div className='container'>
                <div style={{ fontSize: "16px"}}>
                  {searchHelpText.beforeSearchHelpLink || ''}{' '}
                  <Link to= {searchHelpText.searchHelpLinkPath? searchHelpText.searchHelpLinkPath: '/'}>
                    {searchHelpText.searchHelpLinkName || ''}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer submitInquiry={false} showHomeFooter={false} />
      </div>
    )
    return this.countriesMatched() ? jsx : null
  }
}

function mapStateToProps (state) {
  return {
    referenceData: state.referenceData,
    pageContent: state.pageContent,
    permissions: state.permissions
  }
}

export default connect(
  mapStateToProps,
  { notify }
)(Search)



// WEBPACK FOOTER //
// ./src/mi-app/Search.js